import React from "react";
import { useParams } from "react-router-dom";
import ViewVendorBalance from "./ViewVendorBalance";
import ViewSRA from "./ViewSRA";
import ViewInvoiceApproval from "./ViewInvoiceApproval";
import ViewCustomerApproval from "./ViewCustomerApproval";
import ViewTradeMarketing from "./ViewTradeMarketing";
import ViewCustomerBalance from "./ViewCustomerBalance";
import ViewAdvanceGiven from "./ViewAdvanceGiven";
import ViewDepositGiven from "./ViewDepositGiven";
import ViewOther from "./ViewOther";
import ViewCustomerDeposit from "./ViewCustomerDeposit";
import ViewTenderDeposit from "./ViewTenderDeposit";
import ViewVendorAdvance from "./ViewVendorAdvance";
import ViewInventory from "./ViewInventory";
import ViewVendorApproval from "./ViewVendorApproval";

const ViewForm = () => {
  const { sraId } = useParams();
  return (
    <div>
      {sraId?.includes("WOVB") || sraId?.includes("WBVB") ? (
        <ViewVendorBalance />
      ) : sraId?.includes("WOCB") || sraId?.includes("WBCB") ? (
        <ViewCustomerBalance />
      ) : sraId?.includes("WOAG") || sraId?.includes("WBAG") ? (
        <ViewAdvanceGiven />
      ) : sraId?.includes("WODG") || sraId?.includes("WBDG") ? (
        <ViewDepositGiven />
      ) : sraId?.includes("WOI") || sraId?.includes("WBI") ? (
        <ViewInventory />
      ) : sraId?.includes("WOO") || sraId?.includes("WBO") ? (
        <ViewOther />
      ) : sraId?.includes("IA") ? (
        <ViewInvoiceApproval />
      ) : sraId?.includes("CA") ? (
        <ViewCustomerApproval />
      ) : sraId?.includes("TM") ? (
        <ViewTradeMarketing />
      ) : sraId?.includes("CD") ? (
        <ViewCustomerDeposit />
      ) : sraId?.includes("TD") ? (
        <ViewTenderDeposit />
      ) : sraId?.includes("VAD") ? (
        <ViewVendorAdvance />
      ) : sraId?.includes("VA") ? (
        <ViewVendorApproval />
      ) : (
        <ViewSRA />
      )}
    </div>
  );
};

export default ViewForm;
